import React from "react";

import styles from "./winterUnitsBar.module.scss";
import SideBar from "../../../sides/sideBar";
import WinterUnitsTitleClosedBar from "../../../sections/cars/winterUnitsTitleClosedBar";
import SideBarInner from "../../../../shared/sideBarInner";
import CarsSortPanel from "../../../sections/cars/carsSortPanel";
import CarsPaginationSettingsPanel from "../../../sections/cars/carsPaginationSettingsPanel";
import CarsSecondSideBar from "../../../sections/secondSideBars/carsSecondSideBar";
import WinterUnitsTitleBar from "../../../sections/cars/winterUnitsTitleBar";
import WinterUnitsListWrapper from "./WinterUnitsListWrapper";

const WinterUnitsBar = () => {
  return (
    <div className={styles.sideBarsWrapper}>
      <SideBar TitleClosed={<WinterUnitsTitleClosedBar />}>
        <div className={styles.winterUnitsBar}>
          <SideBarInner>
            <WinterUnitsTitleBar />
          </SideBarInner>

          <SideBarInner>
            <CarsSortPanel />
          </SideBarInner>

          <SideBarInner>
            <CarsPaginationSettingsPanel />

            <div className={styles.container_winterUnitsList}>
              <WinterUnitsListWrapper />
            </div>
          </SideBarInner>
        </div>
      </SideBar>

      <CarsSecondSideBar />
    </div>
  );
};

export default React.memo(WinterUnitsBar);
